import isElementACollection from 'editor/src/store/design/selector/isElementACollection';
import { IMAGE_CORRUPTED, MediaImage } from 'editor/src/store/design/types';
import { PluginName } from 'editor/src/store/plugins/types';

import isStaticElement from 'editor/src/util/design/isStaticElement';

// A static image is fixed artwork nobody can fill in again, so an empty one would only be an orphan placeholder.
const canImageBeEmptied = (element: MediaImage) =>
  element.imageId !== IMAGE_CORRUPTED &&
  element.imageId !== '' &&
  !isElementACollection(element) &&
  !element.plugins?.[PluginName.Graphics] &&
  !isStaticElement(element);

export default canImageBeEmptied;
